import { gql } from '@apollo/client';

const legalDocumentFragment = gql`
  fragment LegalDocumentFields on LegalDocument {
    Id
    OrgId
    CompletedDate
    LegalDocumentOrgUnits {
      OrgUnitId
    }
    FileName
  }
`;

export default legalDocumentFragment;
